module.exports = __webpack_public_path__ + "e356b3f3c2f1c32fc515d4e7b32866a0.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/above-the-fold-new-bg2.png
// module id = ./app/images/above-the-fold-new-bg2.png
// module chunks = 40